import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div> </div>`);

const $$css = {
	hash: 'svelte-qv163c',
	code: '.status-log.svelte-qv163c {padding:9px 12px;font-family:var(--font-mono, monospace);font-size:11px;line-height:1.45;min-height:36px;max-height:120px;overflow:auto;white-space:pre-wrap;word-break:break-word;background:var(--color-status-panel, var(--color-panel));}.status-success.svelte-qv163c {color:var(--color-ok, #a6e3a1);}.status-error.svelte-qv163c {color:color-mix(in srgb, var(--color-warn, #f2a65a), var(--color-text-strong) 34%);background:color-mix(in srgb, var(--color-warn, #f2a65a), var(--color-bg) 86%);}.status-info.svelte-qv163c {color:color-mix(in srgb, var(--color-muted), var(--color-accent) 24%);}'
};

export default function Svelte_status_panel($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const message = $.prop($$props, 'message', 7, ''),
		kind = $.prop($$props, 'kind', 7, 'info');

	var $$exports = {
		get message() {
			return message();
		},

		set message($$value = '') {
			message($$value);
			$.flush();
		},

		get kind() {
			return kind();
		},

		set kind($$value = 'info') {
			kind($$value);
			$.flush();
		}
	};

	var div = root();
	var text = $.only_child(div, true);

	$.template_effect(() => {
		$.set_class(div, 1, `status-log status-${kind()}`, 'svelte-qv163c');
		$.set_text(text, message());
	});

	$.append($$anchor, div);

	return $.pop($$exports);
}

customElements.define('lut-status-panel', $.create_custom_element(Svelte_status_panel, { message: {}, kind: {} }, [], []));